import { ShopIconProps } from '@interfaces/Icons'
import { getCloudStoreShop } from '@utils/ShopsUtils'
import { memo } from 'react'

const ShopIcon = (props: ShopIconProps) => {
    
    const { id, size=18, extended=false } = props

    const selectedShop = getCloudStoreShop(id)
    if(!selectedShop) return <i className='bi-question-circle text-muted' style={{opacity: .5, fontSize: `${size}px`}} />

    const name = (extended)?selectedShop.icons.extended: selectedShop.icons.short

    return (
        <img src={`/shops/${name}.png`} alt={name} style={{height: `${size}px`, aspectRatio: 'auto'}} />
    )
}

export default memo(ShopIcon)